import { createContext } from 'react';
import { User } from '@auth0/auth0-react';

export interface AuthContextValue {
  isAuthenticated: boolean;
  isViewOnly: boolean;
  user?: User;
  getAccessToken: ({ cacheMode }: { cacheMode?: 'off' | 'on' }) => Promise<string>;
  requestViewOnly: () => void;
  login: () => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export interface AccessTokenClaims {
  wrt?: boolean;
}
